import {createSvgIcon} from '../create-svg-icon';

export const ReadMoreIcon = createSvgIcon(
  <path d="M13 7h9v2h-9zm0 8h9v2h-9zm3-4h6v2h-6zm-3 1L8 7v4H2v2h6v4z" />
, 'ReadMoreOutlined');
